<template>
  <v-card v-bind="toBind">
    <div class="d-flex flex-no-wrap justify-space-between">
      <v-avatar class="ma-3" size="125" tile>
        <BaseImage :src="item.avatar" :default="placeholder" />
      </v-avatar>

      <div :class="[shouldShowDaySchedule ? 'flex-shrink-0' : 'flex-fill']">
        <v-card-title class="text-h3">{{ item.fullName }}</v-card-title>
        <v-card-text class="text--secondary">
          <div>Стаж:</div>
          <div>Специализация:</div>
          <div>Клиника:</div>
          <div>Услуги:</div>
        </v-card-text>
      </div>

      <v-card-text v-if="shouldShowDaySchedule" class="flex-fill">
        <div v-for="(values, date) in schedule" :key="`${date}`">
          <div class="row row--dense">
            <div v-for="(time, key) in values" :key="`${key}`" class="col-auto">
              <ScheduleTimeButton :doctor="item" :time="time" :event-id="taskEventId" />
            </div>
          </div>
        </div>
      </v-card-text>
    </div>
  </v-card>
</template>

<script>
import placeholder from "@/assets/img/avatar5.png";
import { Doctor } from "@/modules/doctors/Doctor.js";
import BaseImage from "@/components/base/image/BaseImage.vue";
import ScheduleTimeButton from "@/modules/schedule/ScheduleTimeButton.vue";

export default {
  name: "AppointmentCard",
  components: { ScheduleTimeButton, BaseImage },

  props: {
    /** @type {import("vue").PropOptions<Doctor>} */
    item: {
      type: Doctor,
      required: true,
    },
    hasLink: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    placeholder() {
      return placeholder;
    },

    toBind() {
      if (this.hasLink) {
        return {
          to: {
            name: "AppointmentDetail",
            params: { id: this.item.id },
            query: { eventId: this.$route.query.eventId ?? null },
          },
        };
      }

      return {};
    },

    shouldShowDaySchedule() {
      return !this.hasLink && this.item.schedule;
    },

    schedule() {
      if (this.item.schedule) {
        const dateNow = this.$date().unix();
        const schedules = {};

        for (const date in this.item.schedule) {
          /** @type {Object} */
          const times = this.item.schedule[date];
          if (!times) {
            continue;
          }

          const items = [];
          for (const time in times) {
            if (times[time].schedule && times[time].ts > dateNow) {
              items.push(times[time]);
            }
          }

          if (!items.length) {
            continue;
          }

          schedules[date] = items;
        }

        return schedules;
      }

      return {};
    },

    taskEventId() {
      return this.$route.query.eventId ?? null;
    },
  },
};
</script>

<style lang="scss" scoped></style>
